export default {
    methods: {
        /**
         * Returns a formatted label for a given field.
         * @param {Object} field - The field object.
         * @returns {string} - The formatted label.
         */
        getFieldLabel(field) {
            return field.label || field.name
                .charAt(0).toUpperCase() + field.name.slice(1)
                .replace(/[_-]/g, ' ');
        }
    }
};
